const API_URL = process.env.REACT_APP_API_URL
const CDN_URL =
  process.env.REACT_APP_CDN_URL || process.env.REACT_APP_S3_SERVER
const S3_SERVER = process.env.REACT_APP_S3_SERVER

const hasValidCdn =
  Boolean(process.env.REACT_APP_CDN_URL) &&
  !/TU-DISTRIBUCION|example\.com/i.test(process.env.REACT_APP_CDN_URL ?? '')

/** Sin CloudFront: proxy del backend (default). Con CDN: definir REACT_APP_CDN_URL. */
const useProxy =
  process.env.REACT_APP_USE_FILE_PROXY === 'true' ||
  (process.env.REACT_APP_USE_FILE_PROXY !== 'false' && !hasValidCdn)

const encodePath = (imagePath: string): string =>
  imagePath
    .split('/')
    .map((segment) => encodeURIComponent(segment))
    .join('/')

export const getTemplateImageUrl = (imagePath: string): string => {
  if (!imagePath) return ''

  if (useProxy) {
    return `${API_URL}/files?path=${encodeURIComponent(imagePath)}`
  }

  const base = CDN_URL?.endsWith('/') ? CDN_URL : `${CDN_URL}/`
  return `${base}${encodePath(imagePath)}`
}

/** URL directa S3 (suele fallar si el bucket es privado). */
export const getTemplateImageS3Url = (imagePath: string): string => {
  if (!imagePath) return ''
  const base = S3_SERVER?.endsWith('/') ? S3_SERVER : `${S3_SERVER}/`
  return `${base}${encodePath(imagePath)}`
}
